function isString (value) {
  return typeof value === 'string'
}

module.exports = isString



//////////////////
// WEBPACK FOOTER
// ./~/react-faux-dom/lib/utils/isString.js
// module id = 375
// module chunks = 0